import { createSelector } from 'reselect'
import { buildId, getRawId } from 'util/globalId'
import { selectCurrentTicketId } from './selectCurrentTicketId'

export const selectCurrentTicketGlobalId = createSelector(
  selectCurrentTicketId,
  ticketId => buildId('Conversation', getRawId(ticketId))
)
